import { SimpleHeader } from './SimpleHeader';

export default SimpleHeader;
